import { parsePhoneNumber } from 'awesome-phonenumber';
import { mixed, number, object, ObjectSchema, Schema, string, StringSchema } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { SOUNDS } from '~/constants/sounds';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  sound: object().shape({
    name: string().label('サウンド名').required().oneOf(Object.keys(SOUNDS)) as Schema<
      keyof typeof SOUNDS
    >,
    interval: mixed<number | ''>()
      .defined()
      .default('')
      .test(
        '通知間隔',
        '通知間隔が不正な値です',
        (v) => v === '' || (typeof v === 'number' && v > 0),
      ),
  }),
  tel: object().shape({
    enable: string().oneOf(['enabled', 'disabled']).required(),
    phoneNumber: string()
      .label('電話番号')
      .when('enable', ([enable]: 'enabled'[] | 'disabled'[], schema: StringSchema) =>
        enable === 'enabled'
          ? schema
              .required(FormErrorMessage.required)
              .test('telPhoneNumber', FormErrorMessage.invalid, (telPhoneNumber) => {
                return telPhoneNumber
                  ? parsePhoneNumber(telPhoneNumber, { regionCode: 'JP' }).valid
                  : false;
              })
          : schema,
      )
      .defined()
      .default(''),
    delay: number().required(FormErrorMessage.required).min(0),
  }),
  medicationFollowup: string().oneOf(['enabled', 'disabled']).required(),
  online: string().oneOf(['enabled', 'disabled']).required(),
});
